module.exports = __webpack_public_path__ + "static/img/title-banner1-type4.2797eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/title-banner1-type4.png
// module id = RB+h
// module chunks = 1